import React from 'react'
import { createUseStyles } from 'react-jss';
import { FormikProps } from 'formik';
import { IBrand, IMaterialBrandManufacturer } from './MaterialBrandManufacturer.template';
import MultiSelectInput2, { IMultiSelectOption } from '../../../atoms/MultiSelectInput2';
import { IManufacturer } from '../../../pages/AdminMaster/Manufacturer/ManufacturerList.page';
import ButtonV2 from '../../../atoms/ButtonV2';

interface MaterialBrandManufacturerFormTemplateProps {
    handleSelectChange: (key: string) => (option: IMultiSelectOption[]) => void;
    formik: FormikProps<IMaterialBrandManufacturer>;
    manufacturers: IManufacturer[]
    brands: IBrand[]
}

const useStyles = createUseStyles((theme: any) => ({
    primary500: {
        color: theme.palette.textV2.primary.primary500,
    },
    borderColor: {
        border: `1px solid ${theme.palette.backgroundV2.secondary.secondary50}`
    },
    heading: {
        color: theme.palette.textV2.tertiary.tertiary700
    },
    tertiary100Border: {
        borderColor: theme.palette.textV2.tertiary.tertiary100
    },
    sectionBackground: {
        background: theme.palette.backgroundV2.tertiary.tertiary500
    },
    checkbox: {

    }
}));
const MaterialBrandManufacturerFormTemplate:React.FC<MaterialBrandManufacturerFormTemplateProps> = ({formik, handleSelectChange, manufacturers, brands}) => {
    const classes = useStyles();
    
    return (
        <form className={` p-6 grid gap-6 rounded-lg ${classes.sectionBackground}`} onSubmit={formik.handleSubmit}>
            <div className={`grid gap-6`}>
                <div className={`w-full flex justify-between items-center`}>
                    <span className={`${classes.heading} text-2xl`}>Manufacturer/Brand Preference</span>
                    <ButtonV2 variant='tertiaryContained' type="submit" label="Save" className='!font-normal' disabled={!formik.values?.brands?.length}/>
                </div>
                <div className={`${classes.tertiary100Border} border-b`}></div>
                <div className={`grid grid-cols-2 gap-6`}>
                    <MultiSelectInput2
                        {...formik.getFieldProps('manufacturers')}
                        options={manufacturers?.map(option => ({ label: option?.name, value: option?.id }))}
                        label="Manufacturer"
                        
                        onchange={handleSelectChange('manufacturers')}
                        fullWidth
                        placeholder='Select Manufacturer'
                    />
                    <MultiSelectInput2
                        {...formik.getFieldProps('brands')}
                        options={brands?.map(option => ({ label: option?.name, value: option?.name }))}
                        label="Brand"
                       
                        onchange={handleSelectChange('brands')}
                        fullWidth
                        disabled={!!!formik.values?.manufacturers?.length}
                        placeholder='Select Brands'
                    />
                </div>
            </div>
            
        </form>
    )
}

export default MaterialBrandManufacturerFormTemplate